function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 747.03 199.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M687.78,31.13c-32.67,0-59.25,26.58-59.25,59.25s26.58,59.25,59.25,59.25,59.25-26.58,59.25-59.25-26.58-59.25-59.25-59.25ZM687.78,131.13c-22.47,0-40.75-18.28-40.75-40.75s18.28-40.75,40.75-40.75,40.75,18.28,40.75,40.75-18.28,40.75-40.75,40.75Z",
    style: {
      fill: "#54c1ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.54,31.13c-32.67,0-59.25,26.58-59.25,59.25v100c0,5.11,4.14,9.25,9.25,9.25s9.25-4.14,9.25-9.25v-57.05c10.63,10.09,24.97,16.3,40.75,16.3,32.67,0,59.25-26.58,59.25-59.25s-26.58-59.25-59.25-59.25ZM554.54,131.13c-22.47,0-40.75-18.28-40.75-40.75s18.28-40.75,40.75-40.75,40.75,18.28,40.75,40.75-18.28,40.75-40.75,40.75Z",
    style: {
      fill: "#54c1ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.02,35.23c-3.61-3.61-9.47-3.61-13.08,0l-42.28,42.28-42.28-42.28c-3.61-3.61-9.47-3.61-13.08,0-3.61,3.61-3.61,9.47,0,13.08l42.28,42.28-42.28,42.28c-3.61,3.61-3.61,9.47,0,13.08,1.81,1.81,4.17,2.71,6.54,2.71s4.73-.9,6.54-2.71l42.28-42.28,42.28,42.28c1.81,1.81,4.17,2.71,6.54,2.71s4.73-.9,6.54-2.71c3.61-3.61,3.61-9.47,0-13.08l-42.28-42.28,42.28-42.28c3.61-3.61,3.61-9.47,0-13.08Z",
    style: {
      fill: "#54c1ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.82,31.13c-32.67,0-59.25,26.58-59.25,59.25s26.58,59.25,59.25,59.25c13.49,0,26.2-4.42,36.75-12.77,4.01-3.17,4.68-8.99,1.51-12.99-3.17-4.01-8.99-4.68-12.99-1.51-7.25,5.74-15.99,8.78-25.27,8.78-19.29,0-35.48-13.47-39.68-31.5h89.68c5.11,0,9.25-4.14,9.25-9.25,0-32.67-26.58-59.25-59.25-59.25ZM288.82,49.63c19.29,0,35.48,13.47,39.68,31.5h-79.36c4.2-18.03,20.39-31.5,39.68-31.5Z",
    style: {
      fill: "#54c1ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.62,51.71c.34,0,.67.02,1.01.03,13.31-23.38,38.27-39.25,66.99-39.7C122.34,4.38,106.93,0,90.5,0,40.57,0,.08,40.44,0,90.36c13.66-23.12,38.82-38.64,67.62-38.64Z",
    style: {
      fill: "#54c1ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.63,129.26c-.34,0-.67.03-1.01.03C38.82,129.29,13.66,113.77,0,90.64c.08,49.92,40.56,90.36,90.5,90.36,16.43,0,31.84-4.38,45.13-12.04-28.72-.45-53.68-16.32-66.99-39.7Z",
    style: {
      fill: "#0069a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.62,129.29c.34,0,.67-.02,1.01-.03-6.51-11.44-10.25-24.66-10.25-38.76s3.74-27.32,10.25-38.76c-.34,0-.67-.03-1.01-.03C38.82,51.71,13.66,67.23,0,90.36c0,.05,0,.1,0,.14s0,.1,0,.14c13.66,23.12,38.82,38.64,67.62,38.64Z",
    style: {
      fill: "#80d4ff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,90.5c6.85,11.65,10.79,25.22,10.79,39.71s-3.69,27.15-10.12,38.53c26.91-15.68,45-44.85,45-78.24s-18.09-62.56-45-78.24c6.43,11.39,10.12,24.53,10.12,38.53s-3.94,28.06-10.79,39.71Z",
    style: {
      fill: "#0069a6",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.63,51.74c28.43.36,53.21,15.83,66.69,38.76,6.85-11.65,10.79-25.22,10.79-39.71s-3.69-27.15-10.12-38.53c-.12-.07-.25-.15-.37-.22-28.72.45-53.68,16.32-66.99,39.7Z",
    style: {
      fill: "#2293cc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12,130.21c0-14.49-3.94-28.06-10.79-39.71-13.48,22.93-38.26,38.4-66.69,38.76,13.31,23.38,38.27,39.25,66.99,39.7.13-.07.25-.15.37-.22,6.43-11.39,10.12-24.53,10.12-38.53Z",
    style: {
      fill: "#005080",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.753a4c10b578b913d33ae8a6082cb971.svg";
export { ForwardRef as ReactComponent };